import { styled } from '@mui/material/styles';
import { Card } from '@mui/material';

const StyledCard = styled(Card)(({ theme }) => ({
  '&.PCCardRoot': {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.background.secondary,
    borderRadius: theme.spacing(0.75),

    '&.PCSilverPlanCard': {
      border: `1px solid ${theme.palette.divider[2]}`,
      position: 'relative',
      overflow: 'visible',

      '& .MuiButton-contained': {
        backgroundColor: theme.palette.common.white,
        '&:hover': {
          backgroundColor: theme.palette.primary.main,
        },
      },
      '& .PCChip': {
        color: theme.palette.background.default,
        backgroundColor: theme.palette.common.white,
        borderRadius: '6px 6px 0px 0px',
        position: 'absolute',
        top: theme.spacing(-4),
        left: 0,
        right: 0,
        fontSize: theme.typography.pxToRem(14),
        fontWeight: 'bold',
        maxWidth: '50%',
        margin: '0 auto',
      },
    },
    '& .PCCardContent': {
      gap: theme.spacing(4),
      display: 'flex',
      flexDirection: 'column',
    },
    '& .PCCardActions': {
      padding: theme.spacing(2),
    },
    '& .PCplanPrice': {
      lineHeight: 'normal',
    },
    '& .PCPriceSuffix': {
      fontSize: theme.typography.pxToRem(24),
      [theme.breakpoints.down('md')]: {
        fontSize: theme.typography.pxToRem(20),
      },
    },
  },
  '& .PCPlanLogo': {
    '&.IBimgbox':{
       [theme.breakpoints.down('lg')]: {
         width: theme.spacing(8.75),
       },
      },
  },
}));

export default StyledCard;
